// src/components/Topbar.js
import { Search, Menu } from "lucide-react";
import ThemeSwitcher from "./ThemeSwitcher";
import NotificationCenter from "./NotificationCenter";

const PAGE_ACTIONS = {
  dashboard: null,
  activity: null,
  contacts: { label: "New contact", primary: true },
  deals: { label: "New deal", primary: true },
  tasks: { label: "New task", primary: true },
  support: { label: "New ticket", primary: true },
  settings: null,
};

export default function Topbar({
  title,
  page,
  onOpenNav,
  onPageAction,
  onOpenSearch,
  userEmail = "",
  tasks = [],
  onOpenTasks,
}) {
  const action = PAGE_ACTIONS[page];
  const initials = (userEmail && userEmail.slice(0, 2).toUpperCase()) || "—";

  return (
    <header className="topbar">
      <button
        type="button"
        className="topbar-menu-btn topbar-icon-btn"
        aria-label="Open menu"
        onClick={onOpenNav}
      >
        <Menu size={18} strokeWidth={1.75} />
      </button>
      <span className="topbar-title">{title}</span>
      <div className="topbar-actions">
        <button type="button" className="topbar-search-trigger" onClick={onOpenSearch}>
          <Search size={16} strokeWidth={1.75} />
          <span>Search…</span>
          <kbd className="topbar-kbd-hint">⌘K</kbd>
        </button>
        <ThemeSwitcher />
        <NotificationCenter tasks={tasks} userEmail={userEmail} onOpenTasks={onOpenTasks} />
        <div className="topbar-user" title={userEmail}>
          <div className="avatar" style={{ width: 28, height: 28, fontSize: 11, background: "var(--accent-dim)", color: "var(--accent)" }}>
            {initials}
          </div>
          <span className="topbar-user-email topbar-kbd-hint">{userEmail || "Signed in"}</span>
        </div>
        {action && (
          <button
            type="button"
            className={`btn topbar-page-action ${action.primary ? "btn-primary" : ""}`}
            onClick={() => onPageAction?.()}
          >
            + {action.label}
          </button>
        )}
      </div>
    </header>
  );
}
